import React, { useState } from "react"
import FilterSection from "../FilterSection"
import Checkbox from "../Checkbox"
import { ChevronDown } from "lucide-react"

const VISIBLE_LIMIT = 5

const FilterOptionGroup = ({ title, options, selected, onToggle, renderLabel }) => {
  const [expanded, setExpanded] = useState(false)
  if (!options.length) return null
  const visible = expanded ? options : options.slice(0, VISIBLE_LIMIT)
  const hiddenCount = options.length - VISIBLE_LIMIT

  return (
    <FilterSection title={title}>
      {visible.map((opt) => (
        <Checkbox key={opt} checked={selected.has(opt)} onChange={() => onToggle(opt)}>
          {renderLabel ? renderLabel(opt) : opt}
        </Checkbox>
      ))}
      {hiddenCount > 0 && (
        <button
          onClick={() => setExpanded((v) => !v)}
          className="flex items-center gap-1 text-xs text-[#FF6B3D] mt-1.5"
        >
          <ChevronDown
            size={13}
            className={`transition-transform ${expanded ? "rotate-180" : ""}`}
          />
          {expanded ? "Show less" : `Show ${hiddenCount} more`}
        </button>
      )}
    </FilterSection>
  )
}

export default FilterOptionGroup
